<div class="agent-loader {{hideLoader ? 'hidden' : ''}} ">
  <i class="armx-print" style="color:white"></i>
</div>
<div class="row">
  <div class="col-md-12"><div class="col-md-6 col-sm-6"><h3>{{ 'pages.searchReceipt.searchOrCreateReceipt' | translate }}</h3></div></div>
</div>
<div class="row">
  <div class="col-md-12">
    <a class="btn btn-primary pull-right mrgin-btm10p" (click)="newReceipt()">{{ 'pages.searchReceipt.newReceipts' | translate }}</a>
  </div>
</div>
<div class="row">
  <div class="col-md-12 search-row">
    <div class="col-md-4 col-sm-4">
      <label class="mrgin-right15p">{{ 'common.searchBy' | translate }}</label>
      <div class="input-group">
        <div class="input-group-btn">
          <select class="form-control filter-slct" [(ngModel)]="fieldName" (change)="searchReceipt()">
            <option value="ReceiptNumber">{{ 'pages.searchReceipt.receiptNumber' | translate }}</option>
            <option value="ShipmentNumber">{{ 'pages.searchReceipt.shipmentNumber' | translate }}</option>
          </select>
        </div>
        <input type="text" class="form-control serach-input" [placeholder]="'common.search' | translate" [(ngModel)]="searchTerm" (keyup)="searchBykeyWord()">
      </div>
    </div>
    <div class="col-md-2 col-sm-2">
      <div class="form-group">
        <label class="mrgin-right15p">{{ 'common.type' | translate }}</label>
        <select class="form-control filter-slct" [(ngModel)]="receiptTypeId" (change)="searchReceipt()">
          <option value="0">{{ 'common.all' | translate }}</option>
          <option value="1">{{ 'common.inbound' | translate }}</option>
          <option value="2">{{ 'common.outbound' | translate }}</option>
          <option value="3">{{ 'common.miscellaneous' | translate }}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2 col-sm-2">
      <div class="form-group">
        <label class="mrgin-right15p">{{ 'common.canceled' | translate }}</label>
        <select class="form-control filter-slct" [(ngModel)]="isCanceled" (change)="searchReceipt()">
          <option value="false">{{ 'common.no' | translate }}</option>
          <option value="true">{{ 'common.yes' | translate }}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="responsive-table col-md-12">
     <div id="dvamxprint"></div>
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th>{{ 'pages.searchReceipt.receiptNumber' | translate }}</th>
        <th>{{ 'common.date' | translate }}</th>
        <th>{{ 'pages.searchReceipt.hawb' | translate }}</th>
        <th>{{ 'pages.searchReceipt.consignee' | translate }}</th>
        <th>{{ 'pages.searchReceipt.org' | translate }}</th>
        <th>{{ 'pages.searchReceipt.dst' | translate }}</th>
        <th>{{ 'pages.searchReceipt.qty' | translate }}</th>
        <th>{{ 'common.weight' | translate }}</th>
        <th>{{ 'common.canceled' | translate }}</th>
        <th>{{ 'common.actions' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let receipt of receipts; index as i">
        <td style="cursor:pointer !important" (click)="showShipments(i)">{{receipt.Number}} <i *ngIf="receipt.Details.length>1 && showArrow(receipt)" class="{{isColVisable(i) ? 'armx-up-dir' : 'armx-down-dir'}}"></i> </td>
        <td>{{convertoToDate(receipt.CreatedOn)}}</td>
        <td class="{{(returnReceiptData(receipt).IsCancelled && !isColVisable(i)) ? 'deleted':''}}">{{ !isColVisable(i) ?  returnReceiptData(receipt).Number : '&nbsp;'}}
      <tr *ngFor="let shipment of receipt.Details;index as j">
        <td *ngIf="isColVisable(i)" class="{{(shipment.Shipment !=null && shipment.IsCancelled) ? 'deleted' : ''}}">{{shipment.Shipment !=null ? shipment.Shipment?.Number : ''}}</td>
      </tr>
      </td>
    <td class="{{(returnReceiptData(receipt).IsCancelled && !isColVisable(i)) ? 'deleted':''}}">{{ !isColVisable(i) ? returnReceiptData(receipt).ConsigneeName :'&nbsp;'}}
    <tr *ngFor="let shipment of receipt.Details;index as j">
      <td *ngIf="isColVisable(i)" class="{{(shipment.Shipment !=null && shipment.IsCancelled) ? 'deleted' : ''}}">{{shipment.Shipment !=null ? shipment.Shipment?.ConsigneeName : ''}}</td>
    </tr>
    </td>
    <td class="{{(returnReceiptData(receipt).IsCancelled && !isColVisable(i)) ? 'deleted':''}}">{{ !isColVisable(i) ? returnReceiptData(receipt).Origin :'&nbsp;'}}
    <tr *ngFor="let shipment of receipt.Details;index as j">
      <td *ngIf="isColVisable(i)" class="{{(shipment.Shipment !=null && shipment.IsCancelled) ? 'deleted' : ''}}">{{shipment.Shipment !=null ? shipment.Shipment?.Origin : ''}}</td>
    </tr>
    </td>
    <td class="{{(returnReceiptData(receipt).IsCancelled && !isColVisable(i))? 'deleted':''}}">{{ !isColVisable(i) ? returnReceiptData(receipt).Destination :'&nbsp;'}}
    <tr *ngFor="let shipment of receipt.Details;index as j">
      <td *ngIf="isColVisable(i)" class="{{(shipment.Shipment !=null && shipment.IsCancelled) ? 'deleted' : ''}}">{{shipment.Shipment !=null ? shipment.Shipment?.Destination : ''}}</td>
    </tr>
    </td>
    <td class="{{(returnReceiptData(receipt).IsCancelled && !isColVisable(i)) ? 'deleted':''}}">{{ !isColVisable(i) ? returnReceiptData(receipt).Quantity :'&nbsp;'}}
    <tr *ngFor="let shipment of receipt.Details;index as j">
      <td *ngIf="isColVisable(i)" class="{{(shipment.Shipment !=null && shipment.IsCancelled) ? 'deleted' : ''}}">{{shipment.Shipment !=null ? shipment.Shipment?.Quantity : ''}}</td>
    </tr>
    </td>
    <td class="{{(returnReceiptData(receipt).IsCancelled && !isColVisable(i)) ? 'deleted':''}}">{{ !isColVisable(i) ? fixDecimals(returnReceiptData(receipt).ChargeableWeight?.Value) :'&nbsp;'}} {{ !isColVisable(i) ? returnReceiptData(receipt).ChargeableWeight?.Unit :'&nbsp;'}}
    <tr *ngFor="let shipment of receipt.Details;index as j">
      <td *ngIf="isColVisable(i)" class="{{(shipment.Shipment !=null && shipment.IsCancelled) ? 'deleted' : ''}}">{{shipment.Shipment !=null ? fixDecimals(shipment?.Shipment?.ChargeableWeight?.Value) : ''}} {{shipment.Shipment !=null ? shipment.Shipment?.ChargeableWeight?.Unit : ''}}</td>
    </tr>
    </td>

    <td class="{{(returnReceiptData(receipt).IsCancelled && !isColVisable(i))? 'deleted':''}}"> {{ !isColVisable(i) ? cancelTxt(returnReceiptData(receipt).IsCancelled) :'&nbsp;'}}
    <tr *ngFor="let shipment of receipt.Details;index as j">
      <td *ngIf="isColVisable(i)" class="{{(shipment.Shipment !=null && shipment.IsCancelled) ? 'deleted' : ''}}">{{shipment.Shipment !=null ? cancelTxt(shipment.IsCancelled) : ''}}</td>
    </tr>
    </td>

    <td>

      <a *ngIf="canPrintShipment(receipt,'main',receipt.Details)" data-toggle="modal" data-target="#PrintModal" class="action-btn" (click)="setReceiptObj(receipt,i)"><i class="armx-icon armx-print active-print"></i>&nbsp; &nbsp;</a>
      <a *ngIf="canNotPrintShipment(receipt,'main',receipt.Details)" class="action-btn"><i class="armx-icon armx-print deactive-print"></i>&nbsp; &nbsp;</a>

      <a *ngIf="canCancelShipment(receipt,'main',receipt.Details)" class="action-btn" (click)="cancelShipment(receipt,i,receipt.Details,0,'main')">
        <i class="armx-icon armx-cancel active-delete"></i>
      </a>
      <a *ngIf="canNotCancelShipment(receipt,'main',receipt.Details)" class="action-btn" (click)="cancelShipment(receipt,i,receipt.Details,0,'main')">
        <i class="armx-icon armx-cancel deactive-main-delete"></i>
      </a>


    <tr *ngFor="let shipment of receipt.Details;index as j">
      <td *ngIf="shipment.Shipment !=null && isColVisable(i)">

        <a *ngIf="canPrintShipment(receipt,'sub',receipt.Details[j])" class="action-btn">
          <i (click)="printShipment(receipt,i,receipt.Details,j,'sub')" class="armx-icon armx-print active-print"></i>
          &nbsp; &nbsp;
        </a>
        <a *ngIf="canNotPrintShipment(receipt,'sub',receipt.Details[j])" class="action-btn">
          <i class="armx-icon armx-print deactive-print"></i>&nbsp; &nbsp;
        </a>


        <a *ngIf="canCancelShipment(receipt,'sub',receipt.Details[j])" class="action-btn" (click)="cancelShipment(receipt,i,receipt.Details,j,'sub')">
          <i class="armx-icon armx-cancel active-delete"></i>
        </a>
        <a *ngIf="canNotCancelShipment(receipt,'sub',receipt.Details[j])" class="action-btn">
          <i class="armx-icon armx-cancel deactive-delete"></i>
        </a>

      </td>
    </tr>
    </td>
    </tr>
    </tbody>
  </table>
  <div class="row" style="text-align:center">
    <span *ngIf="receipts.length==0">{{ 'pages.searchReceipt.noDataFound' | translate }}</span>
  </div>
</div>
<nav class="nav-pagination">
  <ul class="pagination">
    <li *ngIf="!(pagesContainer <=1) && (pagger != 0)"><button class="btn " (click)="prevPage()"><span class="armx-icon armx-left-dir"></span></button></li>
    <li *ngIf="!(pagesContainer <=1) && pagger >= 3"><button class="btn " (click)="getSearchPage(0)">1</button> ..</li>
    <li *ngFor="let a of pagesContainer; let index = index">
      <button *ngIf="((index == pagger) || (pagger <= index + 5) && (index > pagger - 3 && index < pagger + 5) ) && !(pagesContainer <=1)" (click)="getSearchPage(index)" class="btn  {{index == pagger ? 'active' : 'no'}}">{{index+1}}</button>
      {{index < pagger && index >= pagger+5 ? '.' : ''}}
      <button class="btn " *ngIf="index == pagesContainer.length" (click)="getSearchPage(pagger)">{{pagger + 1  }}</button>
    </li>
    <li *ngIf="!(pagesContainer <=1) && (pagger <= pagesContainer.length-6)">
      ..
      <button class="btn  {{pagesContainer.length == pagger ? 'active' : 'no'}}" (click)="getSearchPage(pagesContainer.length-1)">{{pagesContainer.length}}</button>
      <button class="btn " (click)="nextPage()"><a><span class="armx-icon armx-right-dir"></span></a></button>
    </li>
  </ul>
</nav>

<!-- Modal -->
<div id="PrintModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" (click)="closePaperlessDiv()">&times;</button>
        <h3 class="modal-title">{{ 'pages.searchReceipt.choosePrintingMode' | translate }}</h3>
      </div>
      <div class="modal-body">
        <div class="container" style="width:100%">
          <div class="row">
            <div class="col-md-3"><div class="btn-mode {{printReceiptSelected}}" (click)="selectThePrintMode(1,'')"><img src="../../assets/img/search-receipt/receipt.svg" class="img-responsive"/><span class="red">{{ 'pages.searchReceipt.printReceipts' | translate }}</span></div></div>
            <div class="col-md-3"><div class="btn-mode {{printWaybillSelected}}" (click)="selectThePrintMode(2,'')"><img src="../../assets/img/search-receipt/waybill.svg" class="img-responsive" /><span class="red">{{ 'pages.searchReceipt.printWaybill' | translate }}</span><br />{{ 'pages.searchReceipt.only' | translate }}</div></div>
            <div class="col-md-3" *ngIf="hideCashout == false"><div class="btn-mode {{printCashoutSelected}}" (click)="selectThePrintMode(3,'')"><img src="../../assets/img/search-receipt/cashout.svg" class="img-responsive" /><span class="red">{{ 'pages.searchReceipt.printCashout' | translate }}<br /></span>{{ 'pages.searchReceipt.only' | translate }}</div></div>
            <div class="col-md-3"><div class="btn-mode {{printAll}}" (click)="selectThePrintMode(4,'')"><img src="../../assets/img/search-receipt/all.svg" class="img-responsive" /><span class="red">{{ 'pages.searchReceipt.printAll' | translate }}</span><br />{{printAllLabel}}</div></div>
            <div class="col-md-3" *ngIf="isSpotter == true"><div class="btn-mode {{printPaperless}}" (click)="selectThePrintMode(5,'')"><img src="../../assets/img/search-receipt/LinkingLogo.svg" class="img-responsive" /><span class="red">{{ 'pages.searchReceipt.paperlessLinking' | translate }}</span></div></div>
          </div>
        </div>
        <div *ngIf="isOpen" class="container border" style="width:100%">
          <div *ngFor="let linkShipment of linkShipments; index as i">
          <div class="row">
            <div class="col-md-6"><input type="text" class="form-control" id="CustomerAWB" [(ngModel)]="linkShipment.CustomerAWB" placeholder="Actual shipment number"></div>
            <div class="col-md-6"><input type="text" class="form-control" id="DummyAWB" [(ngModel)]="linkShipment.DummyAWB" placeholder="Dummy Shipment Number"></div>
          </div>
        </div>
          <div class="row">
            <button type="button" class="btn btn-primary" style="float: right;" (click)="LinkAWB()">{{ 'common.link' | translate }}</button>
            <button type="button" class="btn btn-primary" style="float: right; margin-right: 10px;"  data-dismiss="modal" (click)="closePaperlessDiv()">{{ 'common.cancel' | translate }}</button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="printSubmit()">{{ 'common.done' | translate }}</button>
      </div>l
    </div>
  </div>
</div>
